import React from 'react';
import styled from 'styled-components';
import { colors, weights } from '~/styles/index.js';

const List = styled.div`
  max-width: 35rem;
  padding: 0.75rem 0;
  display: flex;
  flex-direction: column;
`;

const Item = styled.div`
  display: flex;
  font-size: 0.75rem;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

const Label = styled.div`
  width: 11.5rem;
  padding-right: 0.5rem;
  color: ${colors.grey40};
  font-weight: ${weights.black};
  letter-spacing: 0.0625rem;
  text-transform: uppercase;
  flex-shrink: 0;
`;

const Heading = styled.div`
  color: ${colors.grey40};
  font-weight: ${weights.black};
  letter-spacing: 0.0625rem;
  text-transform: uppercase;
  white-space: normal;
  align-self: flex-start;
`;

const Value = styled.div`
  white-space: nowrap;
  text-align: right;
  flex: 1;
`;

function ListItem({ label, children }) {
  const wrappedChildren = React.Children.map(children, (child) => (child ? <Value>{child}</Value> : null));
  return (
    <Item>
      <Label>{label}</Label>
      {wrappedChildren}
    </Item>
  );
}

List.Item = ListItem;
List.Heading = Heading;

export default List;
